import type { ConstValues } from '@openx/types/helpers';

export interface TabItem {
  name: string;
  path: string;
  index: number;
}

export const DEAL_INSIGHTS_PATH = '/deal-insights';

export const DEAL_INSIGHTS_PATHS = {
  general: '',
  delivery: 'delivery',
  distribution: 'distribution',
  geolocation: 'geolocation',
};

export const TABS: TabItem[] = [
  { name: 'General', path: DEAL_INSIGHTS_PATHS.general, index: 0 },
  { name: 'Distribution', path: DEAL_INSIGHTS_PATHS.distribution, index: 1 },
  { name: 'Delivery', path: DEAL_INSIGHTS_PATHS.delivery, index: 2 },
  { name: 'Geolocation', path: DEAL_INSIGHTS_PATHS.geolocation, index: 3 },
];

export const dealInsightsStateFields = {
  DATE_RANGE: 'dateRange',
  FILTERS: 'filters',
  LAST_OPENED_FILTER_KEY: 'lastOpenedFilterKey',
} as const;
export type DealInsightsStateFields = ConstValues<typeof dealInsightsStateFields>;

export const dealInsightsDateRangeFields = {
  START_DATE: 'startDate',
  END_DATE: 'endDate',
} as const;
export type DealInsightsDateRangeFields = ConstValues<typeof dealInsightsDateRangeFields>;

export const dateRangeChipOptionId = {
  LAST_QUARTER: 'LAST_QUARTER',
  THIS_MONTH: 'THIS_MONTH',
  LAST_MONTH: 'LAST_MONTH',
  LAST_7_DAYS: 'LAST_7_DAYS',
  LAST_WEEK: 'LAST_WEEK',
  THIS_WEEK: 'THIS_WEEK',
  LAST_3_DAYS: 'LAST_3_DAYS',
  YESTERDAY: 'YESTERDAY',
} as const;
export type DateRangeChipOptionId = ConstValues<typeof dateRangeChipOptionId>;

export const dealInsightsCountries = {
  GLOBAL: 'global',
  UNITED_STATES: 'united states',
} as const;

export type DealInsightsCountries = ConstValues<typeof dealInsightsCountries>;

export const dealInsightsMetrics = {
  IMPRESSIONS: 'impressions',
  SPEND: 'spend',
  CLICKS: 'clicks',
} as const;

export type DealInsightsMetrics = ConstValues<typeof dealInsightsMetrics>;

export const TABLE_PAGE_SIZE = 10;
